export const my_portal_empty_state = {
  empty_title: "You haven't listed any parts yet.",
  empty_cta: "Sell a Part",
};
